module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-welcome-background.58c57e34.png";